<template>
  <a
    class="border px-4 py-2 font-semibold text-white inline-flex items-center space-x-2 rounded m-1 sm:m-2"
    target="_blank"
  >
    <slot />
  </a>
</template>